import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import { AboutSection } from '@terminal/views/theme-overview/tab-content/overview/about-section/AboutSection';
import { RankingMethodologySection } from '@terminal/widgets/knowledge-graph-widget/components/theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { IndustrySectorDistributionSection } from './industry-sector-distribution-section/IndustrySectorDistributionSection';
import styles from './MSOverview.module.scss';
import { MSThemePerformance } from './theme-performance/MSThemePerformance';
import { TopCompaniesSection } from './top-companies-section/TopCompaniesSection';

export const MSOverview = ({ theme }: { theme: any }) => {
  const entityTags = theme.constituents.map(
    (constituent: any) => constituent.entity_tag
  );
  return (
    <div className={styles.root}>
      <div className={styles.topRow}>
        <ErrorBoundaryWrapper showBorder={false}>
          <AboutSection description={theme.description} />
          {/* <RelationshipSection theme={theme} /> */}
          <ErrorMessageWrapper
            variant="empty"
            className={styles.emptyMessage}
          />
        </ErrorBoundaryWrapper>
      </div>
      <ErrorBoundaryWrapper showBorder={false}>
        <MSThemePerformance
          msThemeId={theme.id}
          entityTags={entityTags.slice(0, 10)}
          themesIds={theme.attached_themes.map((theme: any) => theme.theme_id)}
        />
      </ErrorBoundaryWrapper>
      <div className={styles.bottomRow}>
        <ErrorBoundaryWrapper showBorder={false}>
          <div className={styles.bottomRowItem}>
            <IndustrySectorDistributionSection entityTags={entityTags} />
          </div>
        </ErrorBoundaryWrapper>
        <ErrorBoundaryWrapper showBorder={false}>
          <div className={styles.bottomRowItem}>
            <TopCompaniesSection themeId={theme.id} entityTags={entityTags} />
          </div>
        </ErrorBoundaryWrapper>
      </div>
      <div className={styles.rankingWrapper}>
        <RankingMethodologySection rankingType={'themeToCompany'} />
      </div>
    </div>
  );
};
